import saveEventInternal from '../utils/saveEventInternal';
import { orchestrator } from 'satcheljs';
import { saveEvent, saveEventDraft } from 'owa-calendar-compose-form-actions';
import datapoints from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics';

export default orchestrator(saveEvent, () => {
    const perfDatapoint = new PerformanceDatapoint(datapoints.SaveCalendarEvent.name);
    saveEventInternal(perfDatapoint);
});

orchestrator(saveEventDraft, () => {
    const perfDatapoint = new PerformanceDatapoint(datapoints.SaveCalendarDraft.name);
    saveEventInternal(perfDatapoint);
});
